<template>
    <div class="home-quote-step home-info">
        <quote-step-header
            :title="this.step.step_fields.default.title"
            :key="this.step.step_fields.default.title"
            :subtitle="this.step.step_fields.default.subtitle"
        ></quote-step-header>
        <form class="quote-form" @submit.prevent="next">
            <div class="flex flex-wrap">
                <div
                    class="property-address w-full sm:w-1/2 md:w-1/2 lg:w-1/3 sm:pl-3"
                >
                    <app-autocomplete-input
                        label="inputs.city"
                        :message="
                            errors.get('address.city.value') ||
                                errors.get('address.city.label')
                        "
                        :search-cb="searchCities"
                        v-model="form[stepName].address.city"
                    />
                </div>
                <div
                    class="property-address w-full mt-5 sm:mt-0 sm:w-1/2 md:w-1/2 lg:w-1/3 lg:pl-3"
                >
                    <app-autocomplete-input
                        label="inputs.street"
                        :message="
                            errors.get('address.street.value') ||
                                errors.get('address.street.label')
                        "
                        :search-cb="searchStreets"
                        v-model="form[stepName].address.street"
                    />
                </div>

                <div
                    class="property-address w-full mt-5 lg:mt-0 sm:w-full lg:w-1/3"
                >
                    <app-input
                        type="number"
                        v-model="form[stepName].address.building"
                        :message="errors.get('address.building')"
                        label="quote.home.home_info.building"
                    />
                </div>
                <!-- <div
                    class="property-address w-full lg:w-1/3 lg:pl-3 mt-5 lg:mt-10"
                >
                    <app-input
                        type="number"
                        v-model="form[stepName].address.apartment"
                        :message="errors.get('address.apartment')"
                        label="quote.home.home_info.apartment"
                    />
                </div> -->
                <!-- <div class="property-address w-full lg:w-1/3 mt-5 lg:mt-10">
                    <app-input
                        type="number"
                        :disabled="true"
                        v-model="form[stepName].address.postal_code"
                        :loading="loadingZip"
                        :message="errors.get('address.postal_code')"
                        label="quote.home.home_info.postalCode"
                    />
                </div> -->
            </div>

            <app-select
                v-model="form[stepName].number_of_residents"
                :items="residents"
                label="inputs.residnts"
                rounded
            />
            <div>
                <app-label>{{ trans("mortgage") }}</app-label>
                <app-text-radio-buttons
                    :items="mortgageItems"
                    :breakMobile="true"
                    v-model="form[stepName].mortgage"
                />
            </div>
            <div v-if="!isContentOnly">
                <app-label>
                    {{ trans("pipeline_damage") }}
                </app-label>

                <app-text-radio-buttons
                    v-model="form[stepName].pipelineDamage"
                    :breakMobile="true"
                    :items="pipelineDamageItem"
                />
            </div>
            <!-- <div>
                <app-label>{{ trans("concrete") }}</app-label>
                <app-text-radio-buttons
                    :items="concreteItems"
                    :breakMobile="true"
                    v-model="form[stepName].concrete"
                />
            </div>
            <div>
                <app-label>{{ trans("business_activity") }}</app-label>
                <app-text-radio-buttons
                    :items="businessActivityItems"
                    :breakMobile="true"
                    v-model="form[stepName].business_activity"
                />
            </div> -->

            <div class="submit-row">
                <app-button :disabled="disabledConditions" :loading="loading">
                    {{ "quote.welcome.next" | __ }}
                </app-button>
            </div>
        </form>
    </div>
</template>

<script>
import QuoteStep from "../../../mixins/QuoteStep";
import FindZip from "../../../mixins/FindZip";
import AppSelect from "../../Forms/Select.vue";
import AppTextRadioButtons from "../../Forms/TextRadioButtons.vue";
import AppAutocompleteInput from "../../Forms/AutocomplateInput";
import AppInput from "../../Forms/Input.vue";
import { debounce } from "lodash";

export default {
    name: "HomeQuoteInfo",
    components: {
        AppInput,
        AppAutocompleteInput,
        AppSelect,
        AppTextRadioButtons
    },
    mixins: [QuoteStep, FindZip],

    props: {},

    data() {
        return {
            subSteps: ["default"]
        };
    },

    watch: {
        "form.HomeQuoteInfo.address.building": {
            handler: debounce(async function() {
                // Check if city and street are selected
                this.checkIfZipShouldBeSearched();
            }, 500), // Debounce delay in milliseconds
            deep: true
        },
        "form.HomeQuoteInfo.address.city": {
            handler: debounce(async function() {
                // Check if city and street are selected
                this.checkIfZipShouldBeSearched();
            }, 500), // Debounce delay in milliseconds
            deep: true
        },
        "form.HomeQuoteInfo.address.street": {
            handler: debounce(async function() {
                // Check if city and street are selected
                this.checkIfZipShouldBeSearched();
            }, 500), // Debounce delay in milliseconds
            deep: true
        }
    },

    methods: {
        checkIfZipShouldBeSearched() {
            if (
                this.form[this.stepName].address.city &&
                this.form[this.stepName].address.street &&
                this.form[this.stepName].address.building
            ) {
                this.searchZipCodeDebounced(
                    this.form[this.stepName].address.city.label,
                    this.form[this.stepName].address.street.label,
                    this.form[this.stepName].address.building
                );
            }
        },

        async searchZipCodeDebounced(city, street, building) {
            const zip = await this.searchZipCode(city, street, building);
            this.form[this.stepName].address.postal_code = zip;
        },

        async searchCities(term) {
            if (!term) {
                return [];
            }

            const res = await this.$api.get("address/city/search?q=" + term);
            const items = res.data();

            return (items || []).map(city => ({
                value: city.code,
                id: city.id,
                label: city.name
            }));
        },

        async searchStreets(term) {
            const cityId = this.form[this.stepName].address.city.id;

            if (!term || !cityId) {
                return [];
            }

            const res = await this.$api.get(
                "address/street/" + cityId + "/search?q=" + term
            );

            const items = res.data();

            return (items || []).map(city => ({
                value: city.code,
                id: city.id,
                label: city.name
            }));
        }
    },

    computed: {
        insuranceType() {
            return this.form["HomeQuoteSelectDate"].insuranceType;
        },
        isContentOnly() {
            return this.insuranceType === this.constants.content;
        },
        canMoveNext() {
            const form = this.stepFormFields;
            const isNotNull = value => value !== null;

            return (
                !!form.address.city &&
                !!form.address.street &&
                !!form.address.building &&
                // !!form.address.apartment &&
                !!form.number_of_residents &&
                form.mortgage !== null &&
                // form.concrete !== null &&
                // form.business_activity !== null &&
                !this.loadingZip &&
                (!this.notContentOnly || isNotNull(form.pipelineDamage))
            );
        },
        residents() {
            return this.constants.HOME_RESIDENTS;
        },

        pipelineDamageItem() {
            return [
                {
                    label: this.trans("plumber_in_order"),
                    value: this.constants.plumber_in_order
                },
                {
                    label: this.trans("plumber_private"),
                    value: this.constants.plumber_private
                }
            ];
        },
        mortgageItems() {
            return [
                {
                    label: this.trans("yes"),
                    value: true
                },
                {
                    label: this.trans("no"),
                    value: false
                }
            ];
        },
        concreteItems() {
            return [
                {
                    label: this.trans("yes"),
                    value: true
                },
                {
                    label: this.trans("no"),
                    value: false
                }
            ];
        },
        businessActivityItems() {
            return [
                {
                    label: this.trans("yes"),
                    value: true
                },
                {
                    label: this.trans("no"),
                    value: false
                }
            ];
        }
    }
};
</script>

<style lang="scss" scoped>
.home-quote-step {
    .quote-form {
        max-width: $mobile;
        height: auto;
        margin: 0 auto;
    }

    .notice-message {
        font-size: 25px;
        font-weight: $font-light;
        line-height: 1.32;
        color: $primary-blue;
        margin-top: 30px;
    }

    .quote-form {
        margin-top: 40px;
        display: flex;
        flex-direction: column;
        gap: 60px;
    }
}
</style>
